var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "statistic-chart"
  }, [_c('v-chart', _vm._b({}, 'v-chart', {
    options: _vm.options
  }, false)), _c('div', {
    staticClass: "statistic-chart__label"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('b', [_vm._v(" " + _vm._s(_vm.count) + " ")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }